import {
  AsyncOpState,
  DirectoryType,
  DomainSelectionItem,
  GroupMappingItem,
  UserAttributeMapping
} from 'vrlcm-gui-types';

import { StepState } from '@vmware-react/vrlcm';
// eslint-disable-next-line max-len
import { TestConnectionState } from '../../components/directory-management/add-directory/steps/directory-detail-step/test-connection-button/TestConnectionState';

export interface WizardLevelState {
  inprogress: boolean;
  overlayMessage: string;
  submitted: boolean;
}

export interface WizardState {
  wizardLevelState: WizardLevelState;
  currentStep: number; // 0, 1, 2 ..
  stepCount: number;
  steps: Array<{
    valid: boolean;
    disabled: boolean;
    title: string;
    state?: StepState;
  }>;
  groupMappingPageState?: {
    groupMappingPageActive: boolean;
    group?: GroupSelectionItem;
  };
}

export interface BindUserData {
  baseDN: string;
  bindDN: string;
  bindPassword: string;
}

export interface BindUserIwaData {
  bindUserName: string;
  bindPassword: string;
}

export interface JoinDomainData {
  domainName: string;
  domainAdminUserName: string;
  domainAdminPassword: string;
}

export interface CertificateData {
  secureSSLConnectionEnabled: boolean;
  sslCertificate?: string;
}

export interface ServerLocationData {
  aDSupportsDNSServiceLocation: boolean;
  dnsServiceData: {
    directoryHasGlobalCatalog: boolean;
    serverHost: string;
    serverPort: number;
  };
}

export interface SyncDetails {
  connectorInstanceId: string;
  authenticationEnabled: boolean;
  directorySearchAttribute: string;
}

export interface TestConnectionData {
  testConnectionState: TestConnectionState;
  when?: Date;
  errors?: string[];
  runOn?: DirectoryConfigData;
}

export interface ADLdapConfigData {
  directoryName: string;
  syncDetails: SyncDetails;
  serverLocation: ServerLocationData;
  certificateData: CertificateData;
  bindUserData: BindUserData;
}

export interface ADLdapIwaConfigData {
  directoryName: string;
  syncDetails: SyncDetails;
  certificateData: CertificateData;
  bindUserIwaData: BindUserIwaData;
  joinDomainData?: JoinDomainData;
}

export type DirectoryConfigData = ADLdapConfigData | ADLdapIwaConfigData;

export interface MapAttributeData {
  userAttributeMappings: UserAttributeMapping[];
  allAttributesInAD: string[];
}

export interface GroupSelectionItem {
  groupDN: string;
  selectedSubGroups: GroupMappingItem[];
  allSubGroupsSelected: boolean;
  syncResult: {
    syncState: AsyncOpState;
    errorMessage?: string;
    data?: {
      totalSubGroups: number;
      moreThan1000Groups: boolean;
    };
  };
}

export interface GroupSelectionData {
  syncNestedGroup: boolean;
  selectedGroups: GroupSelectionItem[];
}

export interface GroupMappingPageState {
  groupMappingPageActive: boolean;
  group?: GroupSelectionItem;
}

export interface UserSelectionData {
  userDNs: string[];
}

export interface DomainSelectionData {
  domains: DomainSelectionItem[];
}

export interface PreviewData {
  selectedDomainCount: number;
  groups: {
    add: number;
    remove: number;
    update: number;
  };
  users: {
    add: number;
    remove: number;
    update: number;
  };
  mappedUserAttributeCount: number;
  alerts: Array<{
    message: string;
    level: 'info' | 'success' | 'warning' | 'danger';
  }>;
}

export interface WizardData {
  directoryConfigId?: string;
  directoryType: DirectoryType;
  directoryData: DirectoryConfigData;
  domainSelectionData: DomainSelectionData;
  mapAttributeData: MapAttributeData;
  groupSelectionData: GroupSelectionData;
  userSelectionData: UserSelectionData;
  testConnectionData?: TestConnectionData;
  previewData: PreviewData;
}

export interface VidmDetails {
  isVidmFipsMode: boolean;
  version: string;
}

export interface AddDirectory {
  wizardData?: WizardData;
  wizardState?: WizardState;
  wizardInitializeState: AsyncOpState;
  vidmDetails?: VidmDetails;
}

export const initialState: AddDirectory = {
  wizardInitializeState: AsyncOpState.NotStarted
};
